<template>
  <div v-if="open">
    <div class="e-fixture__modal-overlay" @click="closeModal"></div>
    <div class="e-fixture__modal">
      <div class="e-fixture__modal-close" @click="closeModal"></div>
      <div class="e-block__form-label e-block__form-label--grey900">Common household fixtures</div>
      <div class="e-row e-row--gutters16 e-fixture__row">
        <div class="e-col e-col-sm-4" v-for="(fixture, index) in fixtures" :key="`fixture-${index}`">
          <div class="e-fixture e-fixture--modal">
            <div class="e-fixture__img e-fixture__img--modal" :style="{backgroundImage: `url(${fixture.img})`}" />
            <div class="e-fixture__title e-fixture__title--modal">{{ fixture.title }}</div>
            <div class="e-fixture__val">{{ fixture.flowRate }}</div>
          </div>
        </div>
      </div>
      <tip v-if="tip" :text="tip" :relative="true" />
    </div>
  </div>
</template>

<script>
import { commonFixtures } from '@/store';
import Tip from '@/components/ui/Tip.vue';

export default {
  name: 'CommonFixtures',
  components: {
    Tip,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fixtures: commonFixtures,
      tip: '<b>Note</b>: When sizing for a whole home unit, the unit should be as close as possible to the fixtures it services, otherwise it will adversely affect the time to temperature delivery!! It would be highly recommended to size for an additional unit if other fixture locations are further away (beyond 15’ – 20’).',
    };
  },
  computed: {},
  methods: {
    closeModal() {
      this.$emit('modal-close');
    },
  },
};
</script>

<style lang="scss">
</style>
